<template lang="pug">
div.price
  span.price__text(v-html="block.text")
</template>

<script>
export default {
  name: 'PriceComponent',
  props: {
    block: {
      type: Object,
      default: () => {},
    }
  },

}
</script>

<style lang='scss' scoped>
.price {
  background: url('~/assets/images/services/price.svg') no-repeat;
  background-position: top left;
  min-height: 32px;

  &__text {
    display: block;
    padding-left: 2.75rem;
    padding-top: 4px;
  }
}

</style>
